export class Tag {
  public id: string;
  public key: string;
  public name: string;
  public users: string[];
  public tags: string[];
  public rank: number = 0;
  public position: number = 0;
  public insertDate: string;
  public loc: Loc;
  public isDisabled: boolean = false;
  public base: string;
  //
  public email: string;
  public show: boolean = false;
  public edit: boolean = false;
  public checked: boolean = false;

  constructor(
    public hashTag: string,
    public userId: string,
    public source: string, 
    public value: string,) {
  }
}

export class Loc{
  public x: number;
  public y: number;
}



// WEBPACK FOOTER //
// ./src/app/admin/tag/model/tag.ts